import { Click } from '../actions'
import { ChecklistItem, type ChecklistItemProperties } from '../objects/ChecklistItem'

import { analytics } from './lib'

export function ChecklistItemClick(properties: ChecklistItemProperties) {
  return analytics(new Click(), new ChecklistItem(properties))
}
